<template>
  <div>
    <el-footer class="footer f-tac">
      <div class="navNew">
        <nav class="nav">
          <span>
            <router-link to="/article/index1"
              >殡葬文化</router-link
            >
          </span>
          <span>
            <router-link to="/article/index2"
              >党建中心</router-link
            >
          </span>
          <router-link to="/contactus/index">联系我们</router-link>
          <router-link to="/serviceEvaluation/index">服务评价</router-link>
        </nav>
      </div>
      <ul class="icps">
        <li class="icp f-ib">地址：长春市二道区英俊镇666号</li>
        <li class="icp f-ib">联系电话：86-431-84872656 84871395</li>
        <li class="icp f-ib">Email：ccjly@126.com</li>
      </ul>
      <p class="copyright">
        版权所有：长春九龙源殡葬服务有限公司 备案号：吉ICP备2021003041号
      </p>
      <!-- <p class='contact-number'>联系电话：0580-853750</p>
        <p class='contact-number btn' style="margin-top:20px" @click="btnevaluate">服务评价</p> -->
      <!-- <div class="footer-left">
            <p>网站二维码</p>
            <img src="/static/image/wangzhan.png" alt="">
        </div>
        <div class="footer-right">
            <p>微信二维码</p>
            <img src="/static/image/wangzhan.png" alt="">
        </div> -->
    </el-footer>
    <el-dialog
      title="服务评价"
      :visible.sync="valuateDialog"
      width="50%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="姓名" prop="name" placeholder="请输入姓名">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="手机号"
              prop="cellphone"
              placeholder="请输入手机号"
            >
              <el-input v-model="ruleForm.cellphone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="部门" prop="region">
              <el-select v-model="ruleForm.region" placeholder="请选择活动区域">
                <el-option label="服务部" value="shanghai"></el-option>
                <el-option label="礼仪部" value="beijing"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="意见反馈" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc"></el-input>
        </el-form-item>
        <el-form-item label="满意度评价">
          <el-radio v-model="radio" label="1">非常满意</el-radio>
          <el-radio v-model="radio" label="2">满意</el-radio>
          <el-radio v-model="radio" label="3">基本满意</el-radio>
          <el-radio v-model="radio" label="4">不满意</el-radio>
          <el-radio v-model="radio" label="5">非常不满意</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="valuateDialog = false">取 消</el-button>
        <el-button type="primary" @click="valuateDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<style lang="stylus" scoped>
.btn:hover {
  cursor: pointer;
}

.footer {
  position: relative;
  padding: 0;
  font-size: 20px;
}

.navNew {
  height: 46px;
  // background: linear-gradient(180deg, #3781D6, #1E6DCA);
  // background: rgb(160,138,92);
  width: calc(100% - 1px);
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  // opacity:0.3;
}
.nav {
  height: 46px;
  // background: linear-gradient(180deg, #3781D6, #1E6DCA);
  background: #8E8E8E;
  color:#FFFFFF;
  width: 1200px;
  font-size: 22px;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    color: white;
    margin-left: 20px;
    margin-right: 20px;
  }
}

.icps {
  margin-top: 30px;
  color: #020202;

  .icp {
    margin-left: 20px;
    margin-right: 20px;
  }

  .icp-police {
    width: 22px;
    top: 4px;
  }
}

.copyright {
  margin-top: 5px;
  padding-bottom: 5px;
  color: #020202;
}

.contact-number {
}

.footer-left {
  position: absolute;
  left: 413px;
  top: 113px;

  img {
    width: 100px;
    height: 100px;
    background-color: red;
  }
}

.footer-right {
  position: absolute;
  right: 413px;
  top: 113px;

  img {
    width: 100px;
    height: 100px;
    background-color: red;
  }
}
</style>

<script>
export default {
  name: "cfooter",
  data() {
    return {
      valuateDialog: false,
      ruleForm: {
        name: "",
        cellphone: "",
        region: "",
      },
      radio: "1",
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        cellphone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 8,
            max: 11,
            message: "长度在 8 到 11 个字符",
            trigger: "blur",
          },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    setactive(index) {
      this.$store.commit("setactive", index);
    },
    //服务评价弹窗
    btnevaluate() {
      this.valuateDialog = true;
    },
    handleClose() {},
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?3cd4fc38